import React, { useRef } from 'react';
import Card from 'components_v2/common/CardV2';
import Link from 'components/Link';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';
import InViewObserver from '../../../components/InViewObserver/InViewObserver';
import s from './ThreeWidgetSlider.scss';
import Listingheader from '../../../routes/home/components/common/ListingheaderV2';

function renderWidgetList(wdt, ga4Type) {
  if (
    !Array.isArray(wdt.items) ||
    (Array.isArray(wdt.items) && wdt.items.length === 0)
  )
    return null;
  const firstItem = wdt.items[0];
  return (
    <div>
      {wdt.name && (
        <h2 className={s.cardheading}>
          {wdt.path ? (
            <Link
              to={wdt.path}
              className={`${s.linkarrow}`}
              ga4Data={
                ga4Type && [
                  {
                    event: 'user_click',
                    type: `${ga4Type}`,
                    label: `${wdt.name.toLowerCase()}`,
                    category: 'section_heading_click',
                  },
                ]
              }
            >
              {wdt.name}
            </Link>
          ) : (
            wdt.name
          )}
        </h2>
      )}
      <div className="card_wrap">
        {wdt.items.map((item, index) => (
          <Card
            key={item?.id}
            data={item}
            newga={`Click#${wdt.name}_Widget_Story_${index + 1}`}
            onClick={() => {
              if (ga4Type) {
                analyticsWrapper('ga4', {
                  event: 'user_click',
                  type: `${wdt?.ga4Type ? wdt?.ga4Type : ga4Type}`,
                  label: `${wdt.name.toLowerCase()}`,
                  category: 'story_click',
                  story_no: `${index + 1}`,
                  msid: item?.id,
                });
              }
            }}
          />
        ))}
      </div>
      {/* <div className={`${s.links}`}>
        {wdt.items.filter((v, i) => i > 0).map((item, index) => (
          <Link
            to={item.wu}
            newga={`Click#${wdt.name}_Widget_Story_${index + 2}`}
            data={{
              gaAction: 'click',
              gaLabel: `${wdt.name}_Widget_Story_${index + 2}`,
            }}
            ga4Data={
              ga4Type && [
                {
                  event: 'user_click',
                  type: `${wdt?.ga4Type ? wdt?.ga4Type : ga4Type}`,
                  label: `${wdt.name.toLowerCase()}`,
                  category: 'story_click',
                  story_no: `${index + 2}`,
                  msid: item?.id,
                },
              ]
            }
          >
            {item.hl}
          </Link>
        ))}
      </div> */}
    </div>
  );
}

//   getThreeWidgetSlider = wdt => {
//     <ThreeWidgetSlider data={wdt} />;
//   };
function ThreeWidgetSlider(props) {
  const { data, ga4Type } = props;
  //const Ga4Enable = data && data.id === 'threewidgetslider';
  const myRef = useRef();
  if (Array.isArray(data.items) && data.items.length) {
    return (
      <>
        <InViewObserver
          inViewCallback={() => {
            if (ga4Type) {
              analyticsWrapper('ga4', {
                event: 'user_shown',
                type: `${ga4Type}`,
              });
            }
          }}
        >
          {data && data.border && <InterSectionBorder border={data.border} />}
          {data &&
            data.name && (
              <Listingheader
                headingLink={data?.link || data?.path}
                headingname={data.name}
              />
            )}
          <div ref={myRef} className={`${s.storieswrap}`}>
            <ul>
              {data.items.map((item, i) => (
                <li className="resp_container" key={`threewidgetslider${i}`}>
                  <InViewObserver
                    inViewCallback={() => {
                      if (item?.ga4Type) {
                        analyticsWrapper('ga4', {
                          event: 'user_shown',
                          type: `${item?.ga4Type}`,
                        });
                      }
                    }}
                  >
                    {renderWidgetList(item, ga4Type)}
                  </InViewObserver>
                </li>
              ))}
            </ul>
          </div>
        </InViewObserver>
      </>
    );
  }
  return null;
}

export default ThreeWidgetSlider;
